import Constant from '@/common/constant/Constant';
import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import { I18n } from 'aws-amplify';

export const DialogViewNameError = props => {
    const {
        setIsOpenDialogViewNameError,
        inputViewNameRef,
        isOpenDialogViewNameError,
        viewNameErrorType
    } = props;

    const onCloseConfirm = async (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }

        await setIsOpenDialogViewNameError(false);
        await inputViewNameRef.current.focus();
    };

    return (
        <Dialog
            open={isOpenDialogViewNameError}
            onClose={(event, reason) => onCloseConfirm(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirm-dialog-content">
                    {viewNameErrorType === Constant.EDIT_VIEW_NAME_ERROR_TYPE.BLANK &&
                        I18n.get('VIEW_NAME_ERROR_BLANK')}
                    {viewNameErrorType === Constant.EDIT_VIEW_NAME_ERROR_TYPE.DUPLICATE &&
                        I18n.get('VIEW_NAME_ERROR_DUPLICATE')}
                    {viewNameErrorType === Constant.EDIT_VIEW_NAME_ERROR_TYPE.MAX_LENGTH &&
                        I18n.get('VIEW_NAME_ERROR_MAX_LENGTH')}
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    className="btn-hg32 MuiButton-containedPrimary"
                    variant="contained"
                    onClick={(event, reason) => onCloseConfirm(event, reason)}
                >
                    {I18n.get('OK')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
